module.exports = __webpack_public_path__ + "static/media/telegram-icon.feffd239.svg";